goog.provide('el8.ptdata.base');

goog.provide('el8.ptdata.fetch');
goog.provide('el8.ptdata.fetchById');
goog.provide('el8.ptdata.isDeleted');
goog.provide('el8.ptdata.getDocument');
goog.provide('el8.ptdata.getEntitySet');
goog.provide('el8.ptdata.getOrder');
goog.provide('el8.ptdata.getOrderSet');
goog.provide('el8.ptdata.init');
goog.provide('el8.ptdata.model.ptPreferences');
goog.provide('el8.ptdata.ptload');
goog.provide('el8.ptdata.ptTags');
goog.provide('el8.ptdata.smokingStatuses');


goog.require('el8.ptdata.addendums');
goog.require('el8.ptdata.clinicalForms');
goog.require('el8.ptdata.clinicalFormCollections');
goog.require('el8.ptdata.comments');
goog.require('el8.ptdata.dcMedOrders');
goog.require('el8.ptdata.denialMedOrders');
goog.require('el8.ptdata.directMessages');
goog.require('el8.ptdata.documentReminderNotifications');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.ptdata.historyItems');
goog.require('el8.ptdata.implantableDevices');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.ptdata.model.message');
goog.require('el8.ptdata.model.note.nonvisit');
goog.require('el8.ptdata.model.note.visit');
goog.require('el8.ptdata.model.order');
goog.require('el8.ptdata.model.orderSet');
goog.require('el8.ptdata.model.orderSet.referral');
goog.require('el8.ptdata.model.report');
goog.require('el8.ptdata.nonvisitNotes');
goog.require('el8.ptdata.patients');
goog.require('el8.ptdata.pharmacyPrescriptionRequests');
goog.require('el8.ptdata.plrCollaboratorNotifications');
goog.require('el8.ptdata.pmpCheckNotifications');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.ptdata.ptFamilyRelationships');
goog.require('el8.ptdata.ptImmunizations');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.ptdata.ptMaintItems');
goog.require('el8.ptdata.ptNextAppt');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.ptdata.ptRegistrationInfo');
goog.require('el8.ptdata.reports');
goog.require('el8.ptdata.rxHistoryDownloadSummaries');
goog.require('el8.ptdata.rxRefillRequests');
goog.require('el8.ptdata.unreadLetterNotifications');
goog.require('el8.ptdata.vipAccessNotifications');
goog.require('el8.ptdata.visitNotes');
goog.require('el8.ptdata.visitNoteEdits');
goog.require('el8.ptdata.xmlSummaries');
goog.require('el8.ptdata.hl7Messages')

goog.require('el8.appservice.notifier');
goog.require('el8.data.allergies');
goog.require('el8.data.model.tag');
goog.require('el8.model.base');
goog.require('el8.plrdata.base');
goog.require('el8.service.urls');
goog.require('el8.template.ptdata.smokingStatuses');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.base');
goog.require('el8.util.consts');


/**
 * Models that represent patient data live in the ptdata directory.
 * Some of them live directly in this file (generally, smaller models
 * or older ones that haven't been moved out), while some have their own
 * file. But they should generally be goog.require'd in this file and
 * added to getEntitySet.
 */
(function() {
    el8.ptdata.init = function(spec) {
        for (var key in spec) {
            if (spec.hasOwnProperty(key) && spec[key]) {
                // The one exception is currPatient
                switch(key) {
                    case 'currPatient':
                        el8.ptdata.currPatient = el8.ptdata.patients.create(spec[key]);
                        break;
                    case 'currSmokingStatus':
                        el8.ptdata.currSmokingStatus = el8.ptdata.smokingStatuses.create(spec[key]);
                        break;
                    case 'ptPreferences':
                        el8.ptdata.ptPreferences = el8.ptdata.model.ptPreferences(spec[key]);
                        break;
                    case 'ptRegistrationInfo':
                        el8.ptdata.ptRegistrationInfo.populate(spec[key]);
                        break;
                    case 'ptNextAppt':
                        el8.ptdata.ptNextAppt.populate(spec[key]);
                        break;
                    case 'historyItems':
                        for (var subkey in spec[key]) {
                            if (spec[key].hasOwnProperty(subkey)) {
                                // Need to JSON.parse first
                                el8.ptdata[key][subkey].create(JSON.parse(spec[key][subkey]));
                            }
                        }
                        break;
                    default:
                        el8.ptdata[key].create(spec[key]);
                }
            }
        }
    };

    // Pretty much every Document entity set can use this deleteFn.
    // Updating the chart feed should be handled by an event listener in mainFeeds.js
    el8.ptdata.documentDeleteFn = function(item, successCb, errorCb, opts) {
        $.el8_ajax({
            type: 'DELETE',
            url: el8Globals['PATIENT_PATH']+'documents/'+item.getId()+'/',
             // deleteItem will take care of removing from the entity set, which triggers a DELETED
             // event, which should be setup in mainFeeds.js to update the chart feed
            success: successCb,
            error: errorCb
        });
    };


    el8.ptdata.currSmokingStatus = null;
    // This class is only used for convenience, specifically the notify() and listeners. Data we care
    // about will be in el8.ptdata.currSmokingStatus
    el8.ptdata.smokingStatuses = (function() {

        var _class = function(spec) { this.populate(spec); };
        _class.inheritsFrom(el8_Entity);
        _class.makePatientItem();
        _class.addStringProperty('smokingStatus');
        _class.addDate('asOfDate');

        /* Temporary field, shows up in asSoyMap */
        _class.addBoolean('noChange', false, false);

        /**
         *  HELPER METHODS
         */
        _class.prototype.getNoteSummary = function() {
            return el8.template.ptdata.smokingStatuses.noteSummary(this.asSoyMap()).el8_unescape();
        };

        return new el8_EntitySet({
            model: function(spec) { return new _class(spec); }
        });

    })();

    el8.ptdata.ptTags = (function() {
        return new el8_EntitySet({
            model: el8.data.model.tag,
            saveFn: function(item, successCb, errorCb, opts) {
                $.el8_ajax({
                    type: 'POST',
                    async: opts.async,
                    url: el8.service.urls.get('availablePtTags', [item.getId()]),
                    data: JSON.stringify(item.asMap(true)),
                    success: function(data) {
                        item.populate(data);
                        successCb(data);
                    },
                    error: errorCb
                });
            }
        });

    })();

    /**
     * The purpose of this EntitySet is to hold visit notes we don't
     * want to dirty up the el8.ptdata.visitNotes cache.  Right now, main
     * use case is Visit Notes that are in the middle of being amended
     */
    el8.ptdata.tempVisitNotes = (function() {
        return new el8_EntitySet({
            model: function(spec) {
                var that = el8.ptdata.model.note.visit(spec);
                that._temp = true; // stamp to differentiate from regular visit notes (esp debugging)
                return that;
            }
        });
    })();

    el8.ptdata.messageThreads = (function() {
        var that = new el8_EntitySet({model:el8.ptdata.model.message.thread});
        that.setDeleteFn(function(item) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('deleteMessageThread', [item]),
                success: function(data) {
                    if (data) {
                        el8.ptdata.messageThreads.remove(item);
                    } else {
                        el8.uiwidget.alert("Error in trying to delete this item");
                    }
                }
            });
        });
        return that;
    })();

    el8.ptdata.lastVitals = null;

    el8.ptdata.allSignedReferralOrders = el8.ptdata.model.orderSet.referral({
        urlLoad: function() { return el8.service.urls.get('referralOrders'); }
    });
    el8.ptdata.referralOrders = el8.ptdata.model.orderSet.referral();
    el8.ptdata.labOrders = el8.ptdata.model.orderSet('lab');
    el8.ptdata.imagingOrders = el8.ptdata.model.orderSet('imaging');
    el8.ptdata.cardiacOrders = el8.ptdata.model.orderSet('cardiac');
    el8.ptdata.pulmonaryOrders = el8.ptdata.model.orderSet('pulmonary');
    el8.ptdata.sleepOrders = el8.ptdata.model.orderSet('sleep');

    /** Keep this around for now; makes it much easier to manage LHS. Should eventually remove for sure **/
    el8.ptdata.legalReportSetRP = new el8_EntitySet({
        model: el8.ptdata.model.report,
        urlLoad: function() { return el8.service.urls.get('legalReports'); }
    });


    el8.ptdata.ptPreferences = (function() {

        var _class = function(spec) {
            this.populate(spec);
        };
        _class.inheritsFrom(el8_Entity);
        _class.prototype.populate = function(spec) {
            spec = spec || {};
            spec.labCenterSiteId = spec.labCenterId;
            spec.imagingCenterSiteId = spec.imagingCenterId;
            spec.cardiacCenterSiteId = spec.cardiacCenterId;
            spec.pulmonaryCenterSiteId = spec.pulmonaryCenterId;
            spec.sleepCenterSiteId = spec.sleepCenterId;
            this.parent.populate.call(this, spec);
        };

        //These hold Pharmacy Ncpdpids
        _class.addStringProperty('lastPharmacyKey', true); //defined based on selection
        _class.addStringProperty('prefPharmacy1Key', true); //defined by patient demographics form
        _class.addStringProperty('prefPharmacy2Key', true); //defined by patient demographics form

        _class.addIntProperty('labCenterVendorId', true);
        _class.addIntProperty('labVendorPatientSiteId', true);

        // deprecated
        _class.addIntProperty('labCenterId', true);
        _class.addIntProperty('labCenterCompanyId');
        _class.addIntProperty('labCenterSiteId');

        _class.addIntProperty('imagingCenterId', true);
        _class.addIntProperty('imagingCenterCompanyId');
        _class.addIntProperty('imagingCenterSiteId');

        _class.addIntProperty('cardiacCenterId', true);
        _class.addIntProperty('cardiacCenterCompanyId');
        _class.addIntProperty('cardiacCenterSiteId');

        _class.addIntProperty('pulmonaryCenterId', true);
        _class.addIntProperty('pulmonaryCenterCompanyId');
        _class.addIntProperty('pulmonaryCenterSiteId');

        _class.addIntProperty('sleepCenterId', true);
        _class.addIntProperty('sleepCenterCompanyId');
        _class.addIntProperty('sleepCenterSiteId');

        _class.addBoolean('apptRemindersOptOut');

        // can only be called from a patient / chart context
        _class.prototype.refresh = function() {
            var that = this;
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('patientPreferences', [el8Globals.PATIENT_ID]),
                success: function(data) {
                    that.populate(data);
                }
            });
        };

        // can be called in a patient-less context
        _class.prototype.fetchForPatient = function(patientId, callbackFn) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('patientPreferences', [patientId]),
                success: function(data) {
                    // don't populate el8.ptdata.ptPreferences but return
                    // an instance of the same model, for API convenience
                    callbackFn(new _class(data));
                }
            });
        };

        el8.ptdata.model.ptPreferences = function(spec) { return new _class(spec); };

        return el8.ptdata.model.ptPreferences({});

    })();

    // TODO TEST
    // TODO Make this automatically generated when creating entity sets
    el8.ptdata.getEntitySet = function(mClass) {
        switch(mClass) {

            case 'MessageThread':
                return el8.ptdata.messageThreads;
            case 'DiscontinueMedOrder':
                return el8.ptdata.dcMedOrders;
            case 'MedOrder':
                return el8.ptdata.medOrders;
            case "Report":
                return el8.ptdata.reports;
            case "LabOrder":
                return el8.ptdata.labOrders;
            case "ImagingOrder":
                return el8.ptdata.imagingOrders;
            case "SleepOrder":
                return el8.ptdata.sleepOrders;
            case "CardiacOrder":
                return el8.ptdata.cardiacOrders;
            case "PulmonaryOrder":
                return el8.ptdata.pulmonaryOrders;
            case "ReferralOrder":
                return el8.ptdata.referralOrders;
            case "NonvisitNote":
                return el8.ptdata.nonvisitNotes;
            case "VisitNote":
                return el8.ptdata.visitNotes;
            case "DocumentAddendum":
                return el8.ptdata.addendums;
            case "RxRefillRequest":
                return el8.ptdata.rxRefillRequests;
            case "RxHistoryDownloadSummary":
                return el8.ptdata.rxHistoryDownloadSummaries;
            case "ClinicalFormCollection":
                return el8.ptdata.clinicalFormCollections;
            case "DenialMedOrder":
                return el8.ptdata.denialMedOrders;
            case "PharmacyPrescriptionRequest":
                return el8.ptdata.pharmacyPrescriptionRequests;
            case "VisitNoteEdit":
                return el8.ptdata.visitNoteEdits;
            case "MedOrderThread":
                return el8.ptdata.medOrderThreads;
            case "Letter":
                return el8.ptdata.letters;
            case "LetterReceipt":
                return el8.ptdata.letterReceipts;
            case "PatientImmunization":
                // Note: /patient/items won't actually return PatientItems but
                // sometimes it is still useful to fetch locally or get the entity set
                // for a generic ID
                return el8.ptdata.ptImmunizations;
            case "PatientImmunizationDecline":
                return el8.ptdata.ptImmunizationDeclines;
            case "PatientAllergy":
                return el8.ptdata.ptAllergies;
            case "PatientDrugIntolerance":
                return el8.ptdata.ptIntolerances;
            case "PatientProblem":
                return el8.ptdata.ptProblems;
            case "PatientFamilyRelationship":
                return el8.ptdata.ptFamilyRelationships;
            case "VitalsCollection":
                return el8.ptdata.vitalsCollections;
            case "UnreadLetterNotification":
                return el8.ptdata.unreadLetterNotifications;
            case "IncomingDirectMessage":
                return el8.ptdata.directMessages;
            case "XmlPatientSummary":
                return el8.ptdata.xmlSummaries;
            case "Hl7Message":
                return el8.ptdata.hl7Messages;
            case "PatientCollaboratorNotification":
                return el8.ptdata.plrCollaboratorNotifications;
            case "PatientMaintItem":
                return el8.ptdata.ptMaintItems;
            case "DocumentReminderNotification":
                return el8.ptdata.documentReminderNotifications;
            case "VipAccessNotification":
                return el8.ptdata.vipAccessNotifications;
            case "PmpCheckNotification":
                return el8.ptdata.pmpCheckNotifications;
            case "ImplantableDevice":
                return el8.ptdata.implantableDevices;
            case "PrenatalFlowsheet":
                return el8.ptdata.prenatalFlowsheets;
            case "PrenatalFlowsheetVisitMeasurements":
                return el8.ptdata.prenatalFlowsheetVisitMeasurements;
            default:
                return null;
        }
    };
    // TODO auto gen?
    el8.ptdata.getOrderSet = function(type) {
        switch(type) {
            case 'lab': return el8.ptdata.labOrders;
            case "imaging": return el8.ptdata.imagingOrders;
            case "sleep": return el8.ptdata.sleepOrders;
            case "cardiac": return el8.ptdata.cardiacOrders;
            case "pulmonary": return el8.ptdata.pulmonaryOrders;
            case "referral": return el8.ptdata.referralOrders;
            default: return null;
        }
    };

    el8.ptdata.fetchById = function(id) {
        return el8.ptdata.fetch({fetchId: id});
    };

    el8.ptdata.isDeleted = function(id) {
        // use errorOverride to not throw an error if item is deleted
        var result = el8.ptdata.fetch({fetchId: id, errorOverride: function() {}});
        return (result || (result instanceof Array && result.length))? false : true;
    };

    /**
     * Some old code still makes calls like:
     *      el8.ptdata.fetch([{ id: <>, model_class: <>}], false, true...).
     * This reorganizes those arguments to the current API
     */
    function legacyFetchArgs(arg, force, async, callbackFn) {

        var fetchArgs = arg;
        var fetchIds;

        // Support a single id as argument
        if (!(arg instanceof Array)) {
            fetchIds = arg['id'];
        } else {
            fetchIds = fetchArgs.map(function(a) { return a['id']; });
        }

        return {
            fetchIds: fetchIds,
            force: force,
            async: async,
            callbackFn: callbackFn
        };
    }

    /**
     * This function fetches a set of patient documents/items, either from the
     * server or from the local cache. Arguments:
     *  - `fetchId` (a single ID) or `fetchIds` (a list) - stuff to fetch
     *  - async: async request, defaults false
     *  - force: ignore the local cache, defaults false
     *  - callbackFn: will run when the results are ready
     *  - errorOverride: ability to ignore fetch error.  used only to check if item is valid
     *
     * var_args is a "param" because this might be a call using the legacy fetch API,
     * which takes 4 args
     */
    el8.ptdata.fetch = function(opts, var_args) {
        if (!opts) { return null; }

        var errorOverride = opts.errorOverride || null;

        // Calls to the new fetch function always have a dict with the key fetchIds/fetchId in it
        if (!$.isPlainObject(opts) ||
            (!opts.hasOwnProperty('fetchIds') && !opts.hasOwnProperty('fetchId'))) {
                opts = legacyFetchArgs.apply(this, arguments);
        }

        var fetchIds = opts.fetchIds || opts.fetchId;
        if (!fetchIds) { return null; }
        var patientId = opts.patientId || el8Globals.PATIENT_ID;
        var returnSingle = false;
        if (fetchIds instanceof Array) {
            if (!fetchIds.length) { return []; }
        } else {
            fetchIds = [fetchIds];
            returnSingle = true;
        }

        var results = []; // what we'll return
        var needFetch = []; // the subset we'll actually get from the server
        if (opts.force) {
            // if force is true, we need to fetch every object
            needFetch = fetchIds;
            // results is an empty array of the correct length
            results = fetchIds.map(function() { return null; });
        } else {
            // Otherwise try to fetch locally first; only add items we can't find to needFetch
            fetchIds.map(function(id) {
                var entitySet = el8.ptdata.getEntitySet(el8.model.idToModelClass(id));
                var r = entitySet.getById(id, true);
                if (!r) { r = entitySet.getDeletedById(id); }
                results.push(r);
                if (!r) { needFetch.push(id); }
            });
        }
        // At this point, 'results' should be the same length as
        // 'fetchIds' and contain only objects we want to return (null otherwise).
        // Meanwhile, 'needFetch' contains all the ids we need to fetch
        if (needFetch.length) {
            // unfortunate fallback for printforms which don't setup the url service but still use models
            var url = el8.service.urls.get('fetchPatientItems', [patientId]) ||
                el8Globals.PATIENT_PATH + 'items/';
            $.el8_ajax({
                type: 'GET',
                url: url,
                error_override: errorOverride,
                async: (opts.async === true), // defaults to false, i.e. sync call
                data: { id: needFetch },
                success: function(data) {
                    // We assume the results come back in the same
                    // order as we sent up the ids
                    var fetched = data;
                    if (fetched.length !== needFetch.length) {
                        el8.uiwidget.alert('Sorry, there was an error fetching one of '+
                            'the documents you requested');
                    }
                    for(var i=0; i<results.length; i++) {
                        if (!results[i]) {
                            var obj = fetched.shift();
                            var entitySet = el8.ptdata.getEntitySet(obj.model_class);
                            results[i] = entitySet.create(obj, true); // should NOT notify
                        }
                    }
                    if (opts.callbackFn) { opts.callbackFn(); }
                }
            });
        } else {
            if (opts.callbackFn) { opts.callbackFn(); }
        }
        return returnSingle ? results[0] : results;
    };

    el8.ptdata.ptload = function(arg) {
        var items = arg;

        // Support single item as argument
        if (!(arg instanceof Array)) { items = [arg]; }

        var results = [];
        for (var i=0; i<items.length; i++) {
            var entitySet = el8.ptdata.getEntitySet(items[i]['model_class']);
            results.push(entitySet.create(items[i], true)); // should NOT notify
        }
        return results;
    };

    /**
     * Can't use entity_set's refreshById because we don't usually have a urlFn/urlIdFn defined */
    el8.ptdata.refreshDocById = function(id, opts) {
        opts = opts || {};
        var result = null;

        el8.ptdata.fetch({
            fetchId: id,
            force: true,
            async: (opts.async !== false),
            callbackFn: function() {
                var mClass = el8.model.idToModelClass(id);
                var entitySet = el8.ptdata.getEntitySet(mClass);
                var item = entitySet.getById(id);
                if (item) {
                    entitySet.trigger(EVENTS.UPDATED, item);
                } else {
                    entitySet.trigger(EVENTS.DELETED, item);
                }
                if (opts.callbackFn) { opts.callbackFn(item); }
            }
        });

        return result; // only returns anything if synchronous
    };

})();
